// Variant Image Swap — Shrine Pro 1.6.1
(function () {
  function getVariantImages(productHandle, variantId, callback) {
    fetch('/products/' + productHandle + '.js')
      .then(r => r.json())
      .then(product => {
        const variant = product.variants.find(v => v.id === variantId);
        if (!variant || !variant.featured_image) return;
        callback(variant.featured_image);
      });
  }

  function swapMainImage(featuredImage) {
    // Shrine Pro usa Flickity o uno slider nativo — cerchiamo il media attivo
    const mediaId = featuredImage.id;

    // Metodo 1: click sul thumbnail corrispondente (funziona su quasi tutti i temi Shrine)
    const thumbs = document.querySelectorAll(
      '[data-media-id], .product__media-item, .product-single__thumbnail'
    );

    thumbs.forEach(thumb => {
      const id = thumb.dataset.mediaId || thumb.dataset.thumbnailId;
      if (String(id) === String(mediaId)) {
        thumb.click();
      }
    });

    // Metodo 2: fallback — scroll/activate via evento Shopify
    document.dispatchEvent(new CustomEvent('variant:image:swap', {
      detail: { mediaId: mediaId }
    }));
  }

  // Intercetta il cambio variante
  document.addEventListener('change', function (e) {
    const form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;

    const productHandle = form.dataset.productHandle
      || document.querySelector('[data-product-handle]')?.dataset.productHandle;
    if (!productHandle) return;

    // Leggi la variante selezionata
    const variantInput = form.querySelector(
      'input[name="id"], select[name="id"]'
    );
    if (!variantInput) return;

    const variantId = parseInt(variantInput.value, 10);
    if (!variantId) return;

    getVariantImages(productHandle, variantId, swapMainImage);
  });

  // Supporto per variant picker nativo di Shrine (usa eventi custom)
  document.addEventListener('variant:change', function (e) {
    const variant = e.detail?.variant;
    const handle = e.detail?.product?.handle
      || document.querySelector('[data-product-handle]')?.dataset.productHandle;
    if (!variant || !handle || !variant.featured_image) return;
    swapMainImage(variant.featured_image);
  });
})();